const Routes = {
  getRoutes: `Agency/Rails/GetAllRouteArrivalByOrigins`,
};

export default Routes;
